import { clubbiStyled } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('p')(({ theme }) => ({
  width: '100%',
}))
